// Board utility functions

export const getStatusColor = (status) => {
  if (!status) return 'bg-gray-100 dark:bg-gray-700 text-gray-800 dark:text-gray-200';

  const s = status.trim().toLocaleLowerCase('tr-TR');

  if (s.includes('bekle') || s.includes('to do') || s.includes('yeni')) {
    return 'bg-gray-100 dark:bg-gray-700 text-gray-800 dark:text-gray-200';
  }
  if (s.includes('yapılıyor') || s.includes('progress') || s.includes('devam')) {
    return 'bg-blue-100 dark:bg-blue-900 text-blue-800 dark:text-blue-200';
  }
  if (s.includes('bitti') || s.includes('done') || s.includes('tamam')) {
    return 'bg-green-100 dark:bg-green-900 text-green-800 dark:text-green-200';
  }
  if (s.includes('iptal') || s.includes('cancel')) {
    return 'bg-red-100 dark:bg-red-900 text-red-800 dark:text-red-200';
  }
  if (s.includes('test') || s.includes('review')) {
    return 'bg-purple-100 dark:bg-purple-900 text-purple-800 dark:text-purple-200';
  }

  // Varsayılan renk
  return 'bg-blue-50 dark:bg-blue-900/30 text-blue-700 dark:text-blue-300';
};

export const getPriorityColor = (priority) => {
  if (!priority) return 'bg-gray-50 dark:bg-gray-700/50 text-gray-700 dark:text-gray-400 border border-gray-200 dark:border-gray-600';

  const p = priority.toString().toLocaleLowerCase('tr-TR');

  if (p.includes('critical') || p.includes('kritik')) {
    return 'bg-red-50 dark:bg-red-900/20 text-red-700 dark:text-red-400 border border-red-200 dark:border-red-800';
  }
  if (p.includes('high') || p.includes('yüksek')) {
    return 'bg-orange-50 dark:bg-orange-900/20 text-orange-700 dark:text-orange-400 border border-orange-200 dark:border-orange-800';
  }
  if (p.includes('medium') || p.includes('orta')) {
    return 'bg-yellow-50 dark:bg-yellow-900/20 text-yellow-700 dark:text-yellow-400 border border-yellow-200 dark:border-yellow-800';
  }
  if (p.includes('low') || p.includes('düşük')) {
    return 'bg-green-50 dark:bg-green-900/20 text-green-700 dark:text-green-400 border border-green-200 dark:border-green-800';
  }

  return 'bg-gray-50 dark:bg-gray-700/50 text-gray-700 dark:text-gray-400 border border-gray-200 dark:border-gray-600';
};

export const getTypeIcon = (type) => {
  const t = (type || '').toString().toLowerCase();

  if (t.includes('bug') || t.includes('hata')) return '🔧';
  if (t.includes('story') || t.includes('hikaye')) return '🏨';
  if (t.includes('task') || t.includes('görev')) return '✅';
  if (t.includes('epic') || t.includes('destan')) return '🔥';

  return '📋';
};

export const filterTickets = (tickets, searchTerm, statusFilter = '', priorityFilter = '', assigneeFilter = '', currentUser = null) => {
  return tickets.filter(ticket => {
    // Search term filter
    const title = ticket.title || '';
    const tid = String(ticket.id || '');
    const desc = ticket.description || '';

    const matchesSearch = !searchTerm ||
      title.toLowerCase().includes(searchTerm.toLowerCase()) ||
      tid.toLowerCase().includes(searchTerm.toLowerCase()) ||
      desc.toLowerCase().includes(searchTerm.toLowerCase());

    // Status filter
    const matchesStatus = !statusFilter || ticket.status === statusFilter;

    // Priority filter
    const matchesPriority = !priorityFilter || ticket.priority === priorityFilter;

    // Assignee filter
    let matchesAssignee = true;
    if (assigneeFilter) {
      const assigneeName = ticket.assigned_to_user ? `${ticket.assigned_to_user.first_name} ${ticket.assigned_to_user.last_name}`.trim() : null;

      if (assigneeFilter === 'unassigned') {
        matchesAssignee = !assigneeName;
      } else if (assigneeFilter === 'me') {
        if (currentUser) {
          matchesAssignee = (ticket.assigned_to_user?.id === currentUser.id) ||
            (ticket.assigned_to_user?.email === currentUser.email);
        } else {
          matchesAssignee = false;
        }
      } else {
        matchesAssignee = assigneeName === assigneeFilter;
      }
    }

    return matchesSearch && matchesStatus && matchesPriority && matchesAssignee;
  });
};

export const getTicketStats = (tickets) => {
  const stats = {
    total: tickets.length,
    byStatus: {},
    byPriority: {}
  };

  tickets.forEach(ticket => {
    // Status stats
    const status = ticket.status || 'Unknown';
    stats.byStatus[status] = (stats.byStatus[status] || 0) + 1;

    // Priority stats
    const priority = ticket.priority || 'Unknown';
    stats.byPriority[priority] = (stats.byPriority[priority] || 0) + 1;
  });

  return stats;
};

export const sortTicketsByPriority = (tickets) => {
  const priorityOrder = {
    'Critical': 1,
    'High': 2,
    'Medium': 3,
    'Low': 4
  };

  return [...tickets].sort((a, b) => {
    return priorityOrder[a.priority] - priorityOrder[b.priority];
  });
};

export const generateTicketId = (projectKey, ticketCount) => {
  const nextNumber = String(ticketCount + 1).padStart(3, '0');
  return `${projectKey}-${nextNumber}`;
};